export const CONSENTS_SAVE_REQUEST = 'account/CONSENTS_SAVE_REQUEST';
export const CONSENTS_SAVE_SUCCESS = 'account/CONSENTS_SAVE_SUCCESS';
export const CONSENTS_SAVE_FAILURE = 'account/CONSENTS_SAVE_FAILURE';

export const consentsSaveRequest = (consents, source) => ({
  type: CONSENTS_SAVE_REQUEST,
  consents,
  source
});

export const consentsSaveSuccess = () => ({
  type: CONSENTS_SAVE_SUCCESS
});

export const consentsSaveFailure = (error) => ({
  type: CONSENTS_SAVE_FAILURE,
  error
});
